import axios from "axios/index";
// import { chatbot_api_host } from "../../config";
import { chatbot_api_host } from "../../configtest";


/**
 * Adya Feedback Service
 * 
 * Paramters Needed
 *  => SessionId, 
 *  => Rating, 
 *  => Chatbot Login TimeStamp, 
 *  => Chatbot Logout Terminate TimeStamp
 */
export async function sendAdyaUserFeedback(ratingData){
    // console.log("Adya User Feedback Function: ", ratingData);

    return new Promise((resolve, reject)=>{
        axios.post(chatbot_api_host+"/adyaFeedback", ratingData)
    .then((res)=>{
        // console.log("Response: ", res);
        resolve(res);
    })
    .catch((err)=>{
        // console.log("catch error: ", err);
        reject(err);
    })
      })
}

/**
 * Adya Feedback Service
 * 
 * Paramters Needed
 *  => SessionId, 
 *  => Rating, 
 *  => Query, 
 *  => Query Details => need to check what more details
 */
export async function sendUserLikeDislikeFeedback(adyaLikeDislikeData){
    // console.log("Adya User Like Dislike Feedback Function: ", adyaLikeDislikeData);

    return new Promise((resolve, reject)=>{
        axios.post(chatbot_api_host+"/adyaLikeDislike", adyaLikeDislikeData)
    .then((res)=>{
        // console.log("Response: ", res);
        resolve(res);
    })
    .catch((err)=>{
        // console.log("catch error: ", err);
        reject(err);
    })
      })
}